import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'


class TargetFunction extends Component {
  render() {
    const { intl } = this.props
    return (
      <div>
        <div className="container-fluid top-margin">
          <div className="row flexdiv">
            <div className="col-sm-2">
              <div className="home-left bg-white outer-border">
                <div className="sidebar-user">
                  <div className="avatar avatar-initials">
                    <img
                      src={`${process.env.APP_BASE_URL}dist/images/user-img.png`}
                      width="50"
                      alt="User Avatar"
                    />{' '}
                  </div>
                  <div className="sidebar-user-name">
                    {' '}
                    <FormattedMessage
                      id="aspireModule.targetFunction.userName"
                      defaultMessage="Oren Margolis"
                    />
                    <br />
                    <span className="user-info">
                      <FormattedMessage
                        id="aspireModule.targetFunction.userInfo"
                        defaultMessage="MBA Benchmark"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-8 padding-r-l ">
              <div className="row">
                <div className="col-sm-12">
                  <div className="aspire-module outer-border">
                    <div className="card-title">
                      {' '}
                      <span className="text-icon"> in </span>
                      <FormattedMessage
                        id="aspireModule.targetFunction.cardTitle"
                        defaultMessage="Aspire Module"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="home-middle bg-blue">
                    <div className="row">
                      <div className="col-sm-3">
                        {' '}
                        <img
                          src={`${process.env.APP_BASE_URL}dist/images/aspire-header-img.png`}
                          width="220"
                          alt="Aspire Header"
                        />{' '}
                      </div>
                      <div className="col-sm-8 offset-sm-1">
                        <h3>
                          <FormattedMessage
                            id="aspireModule.targetFunction.unleashPowerHeading"
                            defaultMessage={`Unleash the power of your\nlinkedin profile`}
                          />
                        </h3>
                        <p>
                          {' '}
                          <FormattedMessage
                            id="aspireModule.targetFunction.unleashPowerDescription"
                            defaultMessage="Suspendisse nunc odio, euismod in erat et, maximus aliquam ipsum suspendisse potenti nullam pulvinar quam ac sapien malesuada, ut hendrerit justo auctor erat et, maximus aliquam ipsum suspendisse potenti. Nullam pulvinar quam ac sapien malesuada."
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="get-started bg-white">
                    <h2>
                      <FormattedMessage
                        id="aspireModule.targetFunction.getStarted"
                        defaultMessage=" Get started"
                      />
                    </h2>
                    <div className="row border-radius-3 gray-bg width-40-p mx-auto">
                      <div className="col-sm-3">
                        {' '}
                        <img
                          src={`${process.env.APP_BASE_URL}dist/images/user-img.png`}
                          width="70"
                          alt="User Avatar"
                        />
                      </div>
                      <div className="col-sm-9 float-start">
                        <p className="user-name">
                          <FormattedMessage
                            id="aspireModule.targetFunction.profileName"
                            defaultMessage=" Oren Margolis"
                          />
                        </p>
                        <p>
                          <FormattedMessage
                            id="aspireModule.targetFunction.profileDescription"
                            defaultMessage={`www.linkedin.com/Orenmargolis/\nYou signed up with this profile`}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-12 margin-top-10">
                      <a className="btn btn-primary" href="javascript:void(0);">
                        <FormattedMessage
                          id="aspireModule.targetFunction.selectTargetFunction"
                          defaultMessage="Select target function"
                        />
                      </a>
                    </div>
                    <div className="clearfix" />
                    <br />
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="home-right bg-white outer-border">
                {' '}
                <FormattedMessage
                  id="aspireModule.targetFunction.section3"
                  defaultMessage="Section 3"
                />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(TargetFunction)
